module.exports = __webpack_public_path__ + "static/media/SF-17-A.612107ed.mp3";